import React from "react";
import Table from "../../../components/Table";
import { Levensverzekering } from "../../../../../.generated/rapportage/rapportagetypes";
import { getLevensverzekeringColumns } from "../../Producten/levensverzekering-kolommen";

export interface LevensverzekeringTableProps {
  data: Levensverzekering[];
}

export const LevensverzekeringTable: React.FC<LevensverzekeringTableProps> = ({
  data,
}: LevensverzekeringTableProps) => {
  return (
    <div className="levensverzekering-section">
      {data.map((levensverzekering, index) => (
        <div key={index} className="mb-4">
          <Table
            columns={getLevensverzekeringColumns(levensverzekering, true)}
            data={[levensverzekering]}
            rotate={true}
            showHeader={true}
            filterNullAnd0Columns={true}
            appendEmptyCells={true}
            className="break-avoid"
            id={`levensverzekering-table-${levensverzekering.productnaam
              ?.replace(/\s+/g, "-")
              .toLowerCase() || "levensverzekering"}-${index}`}
          />
        </div>
      ))}
    </div>
  );
};
